var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.81H1.5C1.09 6.81 0.75 6.47 0.75 6.06C0.75 5.65 1.09 5.31 1.5 5.31H5.25V1.37C5.25 0.960003 5.59 0.620003 6 0.620003C6.41 0.620003 6.75 0.960003 6.75 1.37V6.06C6.75 6.47 6.41 6.81 6 6.81Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.11 11.31H12.75C12.34 11.31 12 10.97 12 10.56V9.19H9.75C9.34 9.19 9 8.85 9 8.44V4.56C9 4.15 9.34 3.81 9.75 3.81H15.91C16.32 3.81 16.66 4.15 16.66 4.56C16.66 4.97 16.32 5.31 15.91 5.31H10.5V7.69H12.75C13.16 7.69 13.5 8.03 13.5 8.44V9.81H17.11C17.52 9.81 17.86 10.15 17.86 10.56C17.86 10.97 17.52 11.31 17.11 11.31Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.41C11.25 16.82 11.59 17.16 12 17.16C12.41 17.16 12.75 16.82 12.75 16.41V12.81C12.75 12.4 12.41 12.06 12 12.06H8.25V9.81C8.25 9.4 7.91 9.06 7.5 9.06H0.889999C0.479999 9.06 0.139999 9.4 0.139999 9.81C0.139999 10.22 0.479999 10.56 0.889999 10.56H6.75V12.81C6.75 13.22 7.09 13.56 7.5 13.56H11.25V16.41Z",
    fill: "currentColor",
    className: "accent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.06C4.04 18.06 0 14.02 0 9.06C0 4.1 4.04 0.0600014 9 0.0600014C13.96 0.0600014 18 4.1 18 9.06C18 14.02 13.96 18.06 9 18.06ZM9 1.56C4.86 1.56 1.5 4.92 1.5 9.06C1.5 13.2 4.86 16.56 9 16.56C13.14 16.56 16.5 13.2 16.5 9.06C16.5 4.92 13.14 1.56 9 1.56Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d1b6d07fe3a964e2ace58c657672ac14.svg";
export { ForwardRef as ReactComponent };